// @ts-nocheck

import React, { Component } from 'react';
import styles from './ticketsRedeemed.module.scss';
import { Button } from '@ticketmaster/global-design-system';
import { withTranslation } from 'react-i18next';
import { ReactComponent as TicketsRedeemedIcon } from '../../assets/svg/tickets-redeemed-icon.svg';
import { RootContext, StateContext } from '@/root/root.provider';
import { T } from '@/v2/helpers/i18n';

type Props = {} & T;

class TicketsRedeemed extends Component<Props> {
  static contextType: React.Context<StateContext> = RootContext;

  render() {
    const { t } = this.props;
    return (
      <div className={styles.ticketsRedeemed}>
        <TicketsRedeemedIcon className={styles.ticketsRedeemedIcon}/>
        <div className={styles.ticketsRedeemedText}>
          <div className={styles.ticketsRedeemedMessage}>{t('WALLET.TICKETS_REDEEMED.MESSAGE_TICKETS_REDEEMED')}</div>
          <div
            className={styles.ticketsRedeemedLoginMessage}
            dangerouslySetInnerHTML={{ __html: t('WALLET.TICKETS_REDEEMED.MESSAGE_LOGIN') }}
          />
        </div>
        <div>
          <Button fillVariant="outline" onClick={() => window.location.assign(this.context.state.tmOrdersUrl)}>
            {t('WALLET.TICKETS_REDEEMED.LOGIN')}
          </Button>
        </div>
      </div>
    );
  }
}

export default withTranslation('translation')(TicketsRedeemed);
